import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported as isAnalyticsSupported } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyD1p_I7XWM5IWdzxO4TPaVCg-A3OaC0P9c',
  authDomain: 'happa-store.firebaseapp.com',
  projectId: 'happa-store',
  storageBucket: 'happa-store.firebasestorage.app',
  messagingSenderId: '764022211848',
  appId: '1:764022211848:web:13cbf98a837994fa6758bd',
  measurementId: 'G-0TXVY3ZLVT',
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseAuth = getAuth(firebaseApp);
const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: 'select_account',
});

if (typeof window !== 'undefined') {
  void isAnalyticsSupported()
    .then((supported) => {
      if (supported) {
        getAnalytics(firebaseApp);
      }
    })
    .catch(() => undefined);
}

export interface GoogleSignInResult {
  idToken: string;
  email?: string;
  displayName?: string;
}



export const signInWithGooglePopup = async (): Promise<GoogleSignInResult> => {
  const result = await signInWithPopup(firebaseAuth, googleProvider);
  const idToken = await result.user.getIdToken();
  if (!idToken) {
    throw new Error('Google sign-in did not return an id token.');
  }

  return {
    idToken,
    email: result.user.email || undefined,
    displayName: result.user.displayName || undefined,
  };
};
